import { addDoc, getDocs, query, serverTimestamp, updateDoc, where, writeBatch } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { typedDoc } from '@/lib/firestore/converters';
import { notificationsCol, usersCol } from '@/lib/firestore/refs';
import type { Notification } from '@shared/types';

export type NotificationInput = Pick<Notification, 'type' | 'msg' | 'sub' | 'link'>;

export async function notify(recipientUid: string, n: NotificationInput): Promise<void> {
  await addDoc(notificationsCol(), { ...n, recipientUid, read: false, createdAt: serverTimestamp() } as never);
}
export async function notifyMany(uids: string[], n: NotificationInput): Promise<void> {
  await Promise.all([...new Set(uids)].map((uid) => notify(uid, n)));
}
export async function notifyAdmins(n: NotificationInput): Promise<void> {
  const snap = await getDocs(query(usersCol(), where('role', '==', 'admin'), where('active', '==', true)));
  await notifyMany(snap.docs.map((d) => d.data().uid), n);
}
export async function markRead(id: string): Promise<void> {
  await updateDoc(typedDoc<Notification>(db, `notifications/${id}`), { read: true });
}
export async function markAllRead(items: Notification[]): Promise<void> {
  const unread = items.filter((x) => !x.read);
  if (!unread.length) return;
  const batch = writeBatch(db);
  for (const n of unread) batch.update(typedDoc<Notification>(db, `notifications/${n.id}`), { read: true });
  await batch.commit();
}
